import { render, staticRenderFns } from "./component.vue?vue&type=template&id=9ccde4f4&scoped=true&"
import script from "./component.js?vue&type=script&lang=js&"
export * from "./component.js?vue&type=script&lang=js&"
import style0 from "./component.scss?vue&type=style&index=0&id=9ccde4f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccde4f4",
  null
  
)

export default component.exports